import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import '@parcel2go/peacock-legacy-resources';
import App from './App';
ReactDOM.render(
  <Suspense fallback={<React.Fragment />}>
    <App />
  </Suspense>,
  document.getElementById('root'),
);
